export default class PlaceholderFactory {
	constructor(editor, buttonText, placeholderText, description) {
		this.editor = editor;
		this.buttonText = buttonText;
		this.placeholderText = placeholderText;
		this.description = description;
	}

	static createButton(config) {
		// Vytvoříme novou třídu, která dědí z PlaceholderFactory
		return class extends PlaceholderFactory {
			static id = config.id;
			static buttonText = config.buttonText;
			static placeholderText = config.placeholderText;
			static description = config.description;

			// Předáme konfigurační hodnoty do konstruktoru
			constructor(editor) {
				super(editor, config.buttonText, config.placeholderText, config.description);
			}
		};
	}

	async handleClick() {
		this.editor.insertContent(
			`<span class="mceNonEditable" contenteditable="false">${this.placeholderText}</span>`
		);
	}
}
